<footer id="contact" class="site-footer">
  <div class="footer-container">
    <div class="footer-grid align-items-center">

      <!-- Column 1: Logo -->
      <div class="footer-col logo-col">
        <a routerLink="/" class="footer-logo-img">
          <img src="assets/logo/brainy-logo.png" alt="Brainy International" class="img-fluid" style="max-width: 220px; padding: 12px; border-radius: 12px;">
        </a>
      </div>

      <!-- Column 2: Brand Info Center -->
      <div class="footer-col brand-col">
        <h4 class="footer-title" style="color: white; margin-bottom: 0.5rem; font-size: 1.15rem; text-transform: none;">Brainy International Institute of India</h4>
        <p class="brand-desc">
          Quality Education for Scholarly Excellence.<br>
          Brain development training institute empowering children with essential cognitive skills.
        </p>
      </div>

      <!-- Column 3: Programs for Kids -->
      <div class="footer-col">
        <h4 class="footer-title">Students Programme</h4>
        <ul class="footer-links">
          @for (course of kidsPrograms; track course.id) {
            <li><a [routerLink]="['/course', course.slug]">{{ course.title }}</a></li>
          }
        </ul>
      </div>

      <!-- Column 4: Montessori Training -->
      <div class="footer-col">
        <h4 class="footer-title">Educators Programme</h4>
        <ul class="footer-links">
          @for (course of montessoriCourses; track course.id) {
            <li><a [routerLink]="['/course', course.slug]">{{ course.title }}</a></li>
          }
        </ul>
      </div>

    </div>
  </div>

  <div class="footer-bottom">
    <div class="footer-bottom-container">
      <p class="copyright">
        &copy; 2026 All rights reserved to <span class="highlight-text">Brainy International Institute of India</span>.
      </p>
      <p class="developer">
        Designed &amp; Developed by <a href="https://cktechsoln.in" target="_blank" class="highlight-text text-decoration-none">CKTech Solution Pvt Ltd.</a>
      </p>
    </div>
  </div>
</footer>
